import { BLOCK_KEYS, OBJECT_KEYS, CHARACTER_KEYS } from "../constants";

// THUMBNAILS
import lesson01 from "./Thumbnails/pilot-lesson-1_thumbnails.jpeg";
import lesson02 from "./Thumbnails/pilot-lesson-2_thumbnails.jpeg";
import lesson03 from "./Thumbnails/pilot-lesson-3_thumbnails.jpeg";
import lesson04 from "./Thumbnails/pilot-lesson-4_thumbnails.jpeg";
import lesson05 from "./Thumbnails/pilot-lesson-5_thumbnails.jpeg";
import lesson06 from "./Thumbnails/pilot-lesson-6_thumbnails.jpeg";
import lesson06v2 from "./Thumbnails/pilot-lesson-6-v2_thumbnails.jpeg";
import lesson07 from "./Thumbnails/pilot-lesson-7_thumbnails.jpeg";
import lesson07v2 from "./Thumbnails/pilot-lesson-7-v2_thumbnails.jpeg";
import lesson08 from "./Thumbnails/pilot-lesson-8_thumbnails.jpeg";
import lesson09 from "./Thumbnails/pilot-lesson-9_thumbnails.jpeg";
import lesson10 from "./Thumbnails/pilot-lesson-10_thumbnails.jpeg";
import sepLesson01Clifford from "./Thumbnails/sept-2024-pilot-lesson-1-v3_thumbnails.jpeg";
import sepLesson01Galicia from "./Thumbnails/sept-2024-pilot-lesson-1_thumbnails.jpeg";
import sepLesson01Robles from "./Thumbnails/sept-2024-pilot-lesson-1-v2_thumbnails.jpeg";
import sepLesson01Vargas from "./Thumbnails/sept-2024-pilot-lesson-1-v4_thumbnails.jpeg";
import sepLesson02 from "./Thumbnails/sept-2024-pilot-lesson-2-v1_thumbnails.jpeg";
import sepLesson03 from "./Thumbnails/sept-2024-pilot-lesson-3-v1_thumbnails.jpeg";
import octLesson01 from "./Thumbnails/oct-2024-txp-l1_thumbnails.jpeg";
import octLesson02 from "./Thumbnails/oct-2024-txp-l2_thumbnails.jpeg";
import octLesson03 from "./Thumbnails/oct-2024-txp-l3_thumbnails.jpeg";
import softlaunch01 from "./Thumbnails/spring-launch-lesson-1-video_thumbnails.jpeg";
import softlaunch02 from "./Thumbnails/spring-launch-lesson-2-video_thumbnails.jpeg";
import softlaunch03 from "./Thumbnails/spring-launch-lesson-3-video_thumbnails.jpeg";

// GAME BLOCKS
import and from "./Blocks/And.png";
import boom from "./Blocks/Boom.png";
import defeat from "./Blocks/Defeat.png";
import godown from "./Blocks/GoDown.png";
import goleft from "./Blocks/GoLeft.png";
import goright from "./Blocks/GoRight.png";
import goup from "./Blocks/GoUp.png";
import hot from "./Blocks/Hot.png";
import is from "./Blocks/Is.png";
import melt from "./Blocks/Melt.png";
import not from "./Blocks/Not.png";
import open from "./Blocks/Open.png";
import push from "./Blocks/Push.png";
import safe from "./Blocks/Safe.png";
import shut from "./Blocks/Shut.png";
import sink from "./Blocks/Sink.png";
import stop from "./Blocks/Stop.png";
import weak from "./Blocks/Weak.png";
import win from "./Blocks/Win.png";
import you from "./Blocks/You.png";

import andGif from "./Blocks/GIFs/connector_AND.gif";
import isGif from "./Blocks/GIFs/connector_IS.gif";
import notGif from "./Blocks/GIFs/connector_AND.gif";
import boomGif from "./Blocks/GIFs/state_BOOM.gif";
import defeatGif from "./Blocks/GIFs/state_DEFEAT.gif";
import godownGif from "./Blocks/GIFs/state_GO_DOWN.gif";
import goleftGif from "./Blocks/GIFs/state_GO_LEFT.gif";
import gorightGif from "./Blocks/GIFs/state_GO_RIGHT.gif";
import goupGif from "./Blocks/GIFs/state_GO_UP.gif";
import hotGif from "./Blocks/GIFs/state_HOT.gif";
import meltGif from "./Blocks/GIFs/state_MELT.gif";
import openGif from "./Blocks/GIFs/state_OPEN.gif";
import pushGif from "./Blocks/GIFs/state_PUSH.gif";
import safeGif from "./Blocks/GIFs/state_SAFE.gif";
import shutGif from "./Blocks/GIFs/state_SHUT.gif";
import sinkGif from "./Blocks/GIFs/state_SINK.gif";
import stopGif from "./Blocks/GIFs/state_STOP.gif";
import weakGif from "./Blocks/GIFs/state_WEAK.gif";
import winGif from "./Blocks/GIFs/state_WIN.gif";
import youGif from "./Blocks/GIFs/state_YOU.gif";

// GAME OBJECTS
/** @todo update glossary images to match updated assets in Rewriters (hedge) */
import amethyst from "./Objects/Amethyst.png";
import apple from "./Objects/Apple.png";
import ball from "./Objects/Ball.png";
import book from "./Objects/Book.png";
import bookshelf from "./Objects/Bookshelf.png";
import box from "./Objects/Box.png";
import bubble from "./Objects/Bubble.png";
import carrots from "./Objects/Carrots.png";
import chicken from "./Objects/Chicken.png";
import cloud from "./Objects/Cloud.png";
import coin from "./Objects/Coin.png";
import crab from "./Objects/Crab.png";
import crabCowboy from "./Objects/CrabCowboy.png";
import dresserChecker from "./Objects/DresserChecker.png";
import dresserFloral from "./Objects/DresserFloral.png";
import fire from "./Objects/Fire.png";
import fly from "./Objects/Fly.png";
import fossil from "./Objects/Fossil.png";
import frog from "./Objects/Frog.png";
import frogMlem from "./Objects/FrogMlem.png";
import fungus from "./Objects/Fungus.png";
import garnet from "./Objects/Garnet.png";
import gold from "./Objects/Gold.png";
import grass from "./Objects/Grass.png";
import heart from "./Objects/Heart.png";
import ice from "./Objects/Ice.png";
import lava from "./Objects/Lava.png";
import lavaPit from "./Objects/LavaPit.png";
import lavaUnderwater from "./Objects/LavaUnderwater.png";
import map from "./Objects/Map.png";
import moat from "./Objects/Moat.png";
import mushroom from "./Objects/Mushroom.png";
import pearl from "./Objects/Pearl.png";
import puddle from "./Objects/Puddle.png";
import rocks from "./Objects/Rocks.png";
import rocksAlgae from "./Objects/RocksAlgae.png";
import rocksBlue from "./Objects/RocksBlue.png";
import rocksCrystalBlue from "./Objects/RocksCrystalBlue.png";
import rocksCrystalPurple from "./Objects/RocksCrystalPurple.png";
import rocksGrey from "./Objects/RocksGrey.png";
import rocksSnow from "./Objects/RocksSnow.png";
import rocksTidepool from "./Objects/RocksTidepool.png";
import rugPeach from "./Objects/RugPeach.png";
import rugPink from "./Objects/RugPink.png";
import rugTeal from "./Objects/RugTeal.png";
import sandcastle from "./Objects/Sandcastle.png";
import seaweed from "./Objects/Seaweed.png";
import shrub from "./Objects/Shrub.png";
import snow from "./Objects/Snow.png";
import snowball from "./Objects/Snowball.png";
import snowbear from "./Objects/Snowbear.png";
import snowbunny from "./Objects/Snowbunny.png";
import soilCarrots from "./Objects/SoilCarrots.png";
import soilSprout from "./Objects/SoilSprout.png";
import spike from "./Objects/Spike.png";
import starfish from "./Objects/Starfish.png";
import sword from "./Objects/Sword.png";
import tableChecker from "./Objects/TableChecker.png";
import tableLine from "./Objects/TableLine.png";
import treasure from "./Objects/Treasure.png";
import urchin from "./Objects/Urchin.png";
import wallPlatformGrey from "./Objects/WallPlatformGrey.png";
import wallPlatformOrange from "./Objects/WallPlatformOrange.png";
import wallPlatformPlantsGrey from "./Objects/WallPlatformPlantsGrey.png";
import wallPlatformPlantsOrange from "./Objects/WallPlatformPlantsOrange.png";
import water from "./Objects/Water.png";
import watermelon from "./Objects/Watermelon.png";

// GAME CHARACTERS
import enoki from "./Characters/Enoki.png";
import lino from "./Characters/Lino.png";
import lopi from "./Characters/Lopi.png";
import luna from "./Characters/Luna.png";
import mentiMasked from "./Characters/MentiMasked.png";
import mentiUnmasked from "./Characters/MentiUnmasked.png";
import morel from "./Characters/Morel.png";
import olive from "./Characters/Olive.png";
import oliveBowl from "./Characters/OliveBowl.png";
import piney from "./Characters/Piney.png";
import sol from "./Characters/Sol.png";
import zorro from "./Characters/Zorro.png";

// SOUNDS
import notificationSound from "./Sounds/notification-sound-3-262896.mp3";

// TUTORIAL TOOLTIPS
import glossaryTooltipContentImg from "./TutorialTooltips/GlossaryTooltipContentImg.png";

export const thumbnails = {
  lesson01,
  lesson02,
  lesson03,
  lesson04,
  lesson05,
  lesson06,
  lesson07,
  lesson08,
  lesson09,
  lesson10,
  lesson06v2,
  lesson07v2,
  sepLesson01Clifford,
  sepLesson01Galicia,
  sepLesson01Robles,
  sepLesson01Vargas,
  sepLesson02,
  sepLesson03,
  octLesson01,
  octLesson02,
  octLesson03,
  // soft launch
  softlaunch01,
  softlaunch02,
  softlaunch03,
};

export const blockImgsAndGifs = {
  [BLOCK_KEYS.and]: { img: and, gif: andGif },
  [BLOCK_KEYS.boom]: { img: boom, gif: boomGif },
  [BLOCK_KEYS.defeat]: { img: defeat, gif: defeatGif },
  [BLOCK_KEYS.godown]: { img: godown, gif: godownGif },
  [BLOCK_KEYS.goleft]: { img: goleft, gif: goleftGif },
  [BLOCK_KEYS.goright]: { img: goright, gif: gorightGif },
  [BLOCK_KEYS.goup]: { img: goup, gif: goupGif },
  [BLOCK_KEYS.hot]: { img: hot, gif: hotGif },
  [BLOCK_KEYS.is]: { img: is, gif: isGif },
  [BLOCK_KEYS.melt]: { img: melt, gif: meltGif },
  [BLOCK_KEYS.not]: { img: not, gif: notGif },
  [BLOCK_KEYS.open]: { img: open, gif: openGif },
  [BLOCK_KEYS.push]: { img: push, gif: pushGif },
  [BLOCK_KEYS.safe]: { img: safe, gif: safeGif },
  [BLOCK_KEYS.shut]: { img: shut, gif: shutGif },
  [BLOCK_KEYS.sink]: { img: sink, gif: sinkGif },
  [BLOCK_KEYS.stop]: { img: stop, gif: stopGif },
  [BLOCK_KEYS.weak]: { img: weak, gif: weakGif },
  [BLOCK_KEYS.win]: { img: win, gif: winGif },
  [BLOCK_KEYS.you]: { img: you, gif: youGif },
};

export const objectImgs = {
  [OBJECT_KEYS.amethyst]: { img: amethyst },
  [OBJECT_KEYS.apple]: { img: apple },
  [OBJECT_KEYS.ball]: { img: ball },
  [OBJECT_KEYS.book]: { img: book },
  [OBJECT_KEYS.bookshelf]: { img: bookshelf },
  [OBJECT_KEYS.box]: { img: box },
  [OBJECT_KEYS.bubble]: { img: bubble },
  [OBJECT_KEYS.carrots]: { img: carrots },
  [OBJECT_KEYS.chicken]: { img: chicken },
  [OBJECT_KEYS.cloud]: { img: cloud },
  [OBJECT_KEYS.coin]: { img: coin },
  [OBJECT_KEYS.crab]: { img: crab },
  [OBJECT_KEYS.crabCowboy]: { img: crabCowboy },
  [OBJECT_KEYS.dresserChecker]: { img: dresserChecker },
  [OBJECT_KEYS.dresserFloral]: { img: dresserFloral },
  [OBJECT_KEYS.fire]: { img: fire },
  [OBJECT_KEYS.fly]: { img: fly },
  [OBJECT_KEYS.fossil]: { img: fossil },
  [OBJECT_KEYS.frog]: { img: frog },
  [OBJECT_KEYS.frogMlem]: { img: frogMlem },
  [OBJECT_KEYS.fungus]: { img: fungus },
  [OBJECT_KEYS.garnet]: { img: garnet },
  [OBJECT_KEYS.gold]: { img: gold },
  [OBJECT_KEYS.grass]: { img: grass },
  [OBJECT_KEYS.heart]: { img: heart },
  [OBJECT_KEYS.ice]: { img: ice },
  [OBJECT_KEYS.lava]: { img: lava },
  [OBJECT_KEYS.lavaPit]: { img: lavaPit },
  [OBJECT_KEYS.lavaUnderwater]: { img: lavaUnderwater },
  [OBJECT_KEYS.map]: { img: map },
  [OBJECT_KEYS.moat]: { img: moat },
  [OBJECT_KEYS.mushroom]: { img: mushroom },
  [OBJECT_KEYS.pearl]: { img: pearl },
  [OBJECT_KEYS.puddle]: { img: puddle },
  [OBJECT_KEYS.rocks]: { img: rocks },
  [OBJECT_KEYS.rocksAlgae]: { img: rocksAlgae },
  [OBJECT_KEYS.rocksBlue]: { img: rocksBlue },
  [OBJECT_KEYS.rocksCrystalBlue]: { img: rocksCrystalBlue },
  [OBJECT_KEYS.rocksCrystalPurple]: { img: rocksCrystalPurple },
  [OBJECT_KEYS.rocksGrey]: { img: rocksGrey },
  [OBJECT_KEYS.rocksSnow]: { img: rocksSnow },
  [OBJECT_KEYS.rocksTidepool]: { img: rocksTidepool },
  [OBJECT_KEYS.rugPeach]: { img: rugPeach },
  [OBJECT_KEYS.rugPink]: { img: rugPink },
  [OBJECT_KEYS.rugTeal]: { img: rugTeal },
  [OBJECT_KEYS.sandcastle]: { img: sandcastle },
  [OBJECT_KEYS.seaweed]: { img: seaweed },
  [OBJECT_KEYS.shrub]: { img: shrub },
  [OBJECT_KEYS.snow]: { img: snow },
  [OBJECT_KEYS.snowball]: { img: snowball },
  [OBJECT_KEYS.snowbear]: { img: snowbear },
  [OBJECT_KEYS.snowbunny]: { img: snowbunny },
  [OBJECT_KEYS.soilCarrots]: { img: soilCarrots },
  [OBJECT_KEYS.soilSprout]: { img: soilSprout },
  [OBJECT_KEYS.spike]: { img: spike },
  [OBJECT_KEYS.starfish]: { img: starfish },
  [OBJECT_KEYS.sword]: { img: sword },
  [OBJECT_KEYS.tableChecker]: { img: tableChecker },
  [OBJECT_KEYS.tableLine]: { img: tableLine },
  [OBJECT_KEYS.treasure]: { img: treasure },
  [OBJECT_KEYS.urchin]: { img: urchin },
  [OBJECT_KEYS.wallPlatformGrey]: { img: wallPlatformGrey },
  [OBJECT_KEYS.wallPlatformOrange]: { img: wallPlatformOrange },
  [OBJECT_KEYS.wallPlatformPlantsGrey]: { img: wallPlatformPlantsGrey },
  [OBJECT_KEYS.wallPlatformPlantsOrange]: { img: wallPlatformPlantsOrange },
  [OBJECT_KEYS.water]: { img: water },
  [OBJECT_KEYS.watermelon]: { img: watermelon },
};

export const characterImgs = {
  [CHARACTER_KEYS.enoki]: { img: enoki },
  [CHARACTER_KEYS.lino]: { img: lino },
  [CHARACTER_KEYS.lopi]: { img: lopi },
  [CHARACTER_KEYS.luna]: { img: luna },
  [CHARACTER_KEYS.mentiMasked]: { img: mentiMasked },
  [CHARACTER_KEYS.mentiUnmasked]: { img: mentiUnmasked },
  [CHARACTER_KEYS.morel]: { img: morel },
  [CHARACTER_KEYS.olive]: { img: olive },
  [CHARACTER_KEYS.oliveBowl]: { img: oliveBowl },
  [CHARACTER_KEYS.piney]: { img: piney },
  [CHARACTER_KEYS.sol]: { img: sol },
  [CHARACTER_KEYS.zorro]: { img: zorro },
};

export const sounds = { notificationSound };

export const tutorialTooltipImgs = { glossaryTooltipContentImg };
